import { useEffect } from "react";

export const Modal = ({ item, closeDetail }) => {
  const isGallery = Boolean(item.title);
  const title = isGallery ? item.title : item.name;
  const image = isGallery ? item.largeImage : item.bigImage;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") closeDetail();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [closeDetail]);

  return (
    <div className="modal-overlay" onMouseDown={closeDetail} role="presentation">
      <div
        className="modal-panel"
        onMouseDown={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={`${title} 프로젝트 이미지`}
      >
        <div className="modal-toolbar">
          <div>
            <span>{isGallery ? "Selected Work" : "Detail Design"}</span>
            <h2>{title}</h2>
          </div>
          <button type="button" className="modal-close" onClick={closeDetail} aria-label="닫기">
            ×
          </button>
        </div>
        <div className="modal-image-wrap">
          <img src={`/${image}`} alt={`${title} 프로젝트`} />
        </div>
      </div>
    </div>
  );
};
